﻿/**
 * Class to work as a DTO to hold the information of a event dispatched the speedcurve mark start event.
 */
class SpeedcurveMarkStart {
  constructor(name) {
    this.name = name;
  }

  /**
   * The function returns the value of the name property.
   * @returns The value of the variable `name`.
   */
  getName() {
    return this.name;
  }
}

export default SpeedcurveMarkStart;
